import { QueryCache, QueryClient } from 'react-query';

export const queryCache = new QueryCache();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60000,
      useErrorBoundary: false,
      refetchOnWindowFocus: false,
    },
  },
  queryCache,
});
